import React from 'react';
import { FDStack, FDAvatar, FDIcon } from '@facet-wealth/design';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import fr from 'facet-rest';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import { dataAttrs } from 'Helpers/Testing';

const PlannerSummaryLayout = () => {
  const { resource } = useMetaLayoutContext();
  const { loadPageContentLink } = usePageContentContext();

  const handleClick = () => {
    resource.withRelationship(
      fr.relationships.managedAccountModelUpdateRequestPage.name,
      (rel) => {
        loadPageContentLink(rel.link('related'));
      },
      () => null,
    );
  };

  return (
    <div
      onClick={handleClick}
      role="presentation"
      style={{ cursor: 'pointer' }}
      {...dataAttrs('dop-view-planner-item')}
    >
      <FDStack direction="row" spacing={2} alignItems="center">
        <FDAvatar
          alt={resource.relationship(fr.relationships.profileImage.name)?.meta('altText') || ''}
          src={resource.relationship(fr.relationships.profileImage.name)?.link('related').url() || ''}
          size={'md'}
        />
        <FDStack direction="column" spacing={1} flex={1}>
          <MetaControlField attr="agentName" />
        </FDStack>
        <FDStack direction="row" spacing={1} flex={1}>
          <FDStack alignItems={'center'} spacing={1}>
            <FDIcon name="circle" color="error" />
            <MetaControlField attr="noModelAssignedCount" />
          </FDStack>
          <FDStack alignItems={'center'} spacing={1}>
            <FDIcon name="circle" color="warning" />
            <MetaControlField attr="modelsDoNotMatchCount" />
          </FDStack>
          <FDStack alignItems={'center'} spacing={1}>
            <FDIcon name="circle" color="success" />
            <MetaControlField attr="inTradingCount" />
          </FDStack>
        </FDStack>
      </FDStack>
    </div>
  );
};

PlannerSummaryLayout.defaultProps = {};
PlannerSummaryLayout.propTypes = {};

export default PlannerSummaryLayout;
